
<template>

  <div class="col-lg-12">
    <div class="main-card mb-3 card" >
      <div class="card-body" style="text-align:center; padding-top:60px;">
        <img src="https://mypathkr.com/img/parking.png" style="width:380px;" />
        <div style="margin-bottom:100px;">현재 페이지는 공사중입니다. ^^</div>
</div>
</div>
</div>
</template>
